// require('./bootstrap');
try {
    window.$ = window.jQuery = require('jquery');
    window.Popper = require('popper.js').default; // default is very important.
    require('bootstrap');
    require('./owl.carousel');
    // console.log(window.Popper);
} catch (e) {
	console.log(e);
}